import * as React from "react"
import Button from "@mui/material/Button"
import Grid from "@mui/material/Grid"
import SearchIcon from '@mui/icons-material/Search';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PaidIcon from '@mui/icons-material/Paid';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/Info';
import {
    DataGrid,
} from "@mui/x-data-grid"
import { AXIOS_API_INSTANCE, RENTAL_CONTRACT_COLOR_MAP } from "../../Constants"
import { send_authorized_request } from "../../Constants/cognito"
import axios from "axios"
import { useSnackbar } from 'notistack';
import { useCookies } from "react-cookie"
import { SimpleCustomToolbar } from "../CustomToolbar"
import onFilterChange from "../../Utils/OnFilterChange"
import { Box, Chip, InputAdornment, TextField, Tooltip, debounce } from "@mui/material"
import dayjs from "dayjs"
import timezone from "dayjs/plugin/timezone";
import { useNavigate, useParams } from "react-router-dom"
import Contract from "./Contract"
import { useTrackedLocation } from "../UserState"
dayjs.extend(timezone);

const MY_COLORS = RENTAL_CONTRACT_COLOR_MAP

const columns = [
    {
        field: "status",
        headerName: "Status",
        width: 150,
        editable: false,
        renderCell: (params) => {
            if (params.row.status === 'RESERVED') {
                return (<Chip icon={<AccessTimeFilledIcon />} label="Reserved" color={MY_COLORS["RESERVED"]} />)
            } else if (params.row.status === 'CHECKING_OUT') {
                return (<Chip icon={<PaidIcon />} label="Checking Out" color={MY_COLORS["CHECKING_OUT"]} />)
            } else if (params.row.status === 'CHECKED_OUT') {
                return (<Chip icon={<AccessTimeFilledIcon />} label="Checked Out" color={MY_COLORS["CHECKED_OUT"]} />)
            } else if (params.row.status === 'CHECKING_IN') {
                return (<Chip icon={<PaidIcon />} label="Checking In" color={MY_COLORS["CHECKING_IN"]} />)
            } else if (params.row.status === 'CHECKED_IN') {
                return (<Chip icon={<CheckCircleIcon />} label="Complete" color={MY_COLORS["CHECKED_IN"]} />)
            } else if (params.row.status === 'CANCELED') {
                return (<Chip icon={<CancelIcon />} label="Canceled" color={MY_COLORS["CANCELED"]} />)
            } else {
                return (<span></span>)
            }
        }
    },
    {
        field: "name",
        headerName: "Name",
        width: 200,
        editable: false,
        sortable: false,
        filterable: false,
        valueGetter: (params) => params.row.customer.name || ""
    },
    {
        field: "phone",
        headerName: "Phone",
        width: 200,
        editable: false,
        sortable: false,
        filterable: false,
        valueGetter: (params) => params.row.customer.phone || ""
    },
    {
        field: "start_date",
        headerName: "Start",
        type: 'datetime',
        editable: false,
        flex: 1,
        renderCell: (params) => {
            const start_time = dayjs.utc(params.row.start_date || params.row.estimated_start_date)
            const start_time_str = start_time.local().format('ddd, D MMM YYYY h:mm A')
            return (
                <Box>
                    {!params.row.start_date && start_time < dayjs.utc() &&
                        <Tooltip title={`${Math.floor(dayjs.utc().diff(start_time) / 3.6e+6)} hrs past reservation date`}>
                            <InfoIcon sx={{ height: '20px', verticalAlign: 'text-bottom' }} color="error" />
                        </Tooltip>
                    }
                    {!params.row.start_date &&
                        <AccessTimeIcon sx={{ height: '20px', verticalAlign: 'text-bottom' }} />
                    }
                    <span>{start_time_str}</span>
                </Box>
            )
        }
    },
    {
        field: "end_date",
        headerName: "End",
        type: 'datetime',
        editable: false,
        flex: 1,
        renderCell: (params) => {
            const end_time = dayjs.utc(params.row.end_date || params.row.estimated_end_date)
            const end_time_str = end_time.local().format('ddd, D MMM YYYY h:mm A')
            return (
                <Box>
                    {!params.row.end_date && end_time < dayjs.utc() &&
                        <Tooltip title={`${Math.floor(dayjs.utc().diff(end_time) / 3.6e+6)} hrs past reservation date`}>
                            <InfoIcon sx={{ height: '20px', verticalAlign: 'text-bottom' }} color="error" />
                        </Tooltip>
                    }
                    {!params.row.end_date &&
                        <AccessTimeIcon sx={{ height: '20px', verticalAlign: 'text-bottom' }} />
                    }
                    <span>{end_time_str}</span>
                </Box>
            )
        }
    },
]

export default function Contracts(props) {
    const { enqueueSnackbar } = useSnackbar();
    const [cookies, setCookie] = useCookies(["pagination"])
    const [paginationModel, setPaginationModel] = React.useState({
      pageSize: cookies.pagination?.contracts_pageSize || 10,
      page: 0,
    });
    const [selectedLocation,] = useTrackedLocation(); // REMOVED setSelectedLocation to make linter happy
    const [rowData, setRowData] = React.useState({ rows: [], total_count: 0 })
    const [sorting, setSorting] = React.useState({ field: 'estimated_start_date', sort: 'asc' })
    const [filtering, setFiltering] = React.useState({})
    const [isLoading, setIsLoading] = React.useState(true)
    const [includeReserved, setIncludeReserved] = React.useState(true)
    const [includeCheckedOut, setIncludeCheckedOut] = React.useState(true)
    const [includeCheckingIn, setIncludeCheckingIn] = React.useState(true)
    const [includeCheckedIn, setIncludeCheckedIn] = React.useState(false)
    const [includeCanceled, setIncludeCanceled] = React.useState(false)
    const [rentalContractSearch, setRentalContractSearch] = React.useState('')
    const navigate = useNavigate();
    console.log("RENDERING Contracts")
    console.log(JSON.stringify(cookies))
    console.log(JSON.stringify(rowData))
    console.log(JSON.stringify(isLoading))

    const { contractId } = useParams();

    const contractsRowClick = (data) => {
        navigate(`/Contracts/${data.row.id}`)
    }

    const setMyPaginationModel = (model) => {
        setCookie(
            "pagination",
            { ...cookies.pagination, contracts_pageSize: model.pageSize },
            { path: "/" }
        )
        setPaginationModel(model)
    }

    const updateRentalContractSearch = (event) => {
        setRentalContractSearch(event.target.value.trim())
        if (event.target.value.trim() !== rentalContractSearch) {
            debouncedGetContracts(getContracts, paginationModel, sorting.field, sorting.sort, filtering, event.target.value.trim())
        }
    }

    const getContracts = (paginationModel, sortField, sortDirection, filterVar, rentalContractSearch) => {
        setIsLoading(true)
        let my_filters = { "and": [] }
        if (Object.keys(filterVar).length > 0) {
            my_filters["and"].push(filterVar)
        }
        if (rentalContractSearch.length > 0) {
            my_filters['and'].push({
                'or': [
                    { 'customer:name.ilike': rentalContractSearch },
                    { 'customer:phone.ilike': rentalContractSearch },
                ]
            })
        }
        if (selectedLocation.id !== "all") {
            my_filters['location_id.eq'] = selectedLocation.id
        }
        my_filters["and"].unshift({ 'or': [] })
        if (includeReserved) {
            my_filters["and"][0]['or'].push({ 'status.eq': 'RESERVED' })
        }
        if (includeCheckedOut) {
            my_filters["and"][0]['or'].push({ 'status.eq': 'CHECKED_OUT' })
        }
        if (includeCheckingIn) {
            my_filters["and"][0]['or'].push({ 'status.eq': 'CHECKING_IN' })
        }
        if (includeCheckedIn) {
            my_filters["and"][0]['or'].push({ 'status.eq': 'CHECKED_IN' })
        }
        if (includeCanceled) {
            my_filters["and"][0]['or'].push({ 'status.eq': 'CANCELED' })
        }
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentalcontracts", {
                        params: {
                            page_num: paginationModel.page,
                            page_size: paginationModel.pageSize,
                            order_by: sortField,
                            order_by_direction: sortDirection,
                            filters: JSON.stringify(my_filters),
                        },
                    }),
                ])
                .then(
                    axios.spread((contracts) => {
                        console.log(contracts)
                        setRowData({
                            rows: contracts.data.data,
                            total_count: contracts.data.total_count,
                        })
                        setIsLoading(false)
                    })
                ).catch((error) => {
                    enqueueSnackbar(`Failed to load contracts: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
                    setIsLoading(false)
                })
        )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedGetContracts = React.useMemo(() => debounce((getContracts, paginationModel, sortField, sortDirection, filterVar, rentalContractSearch) => getContracts(paginationModel, sortField, sortDirection, filterVar, rentalContractSearch), 400), []);

    React.useEffect(() => {
        if (contractId === undefined) {
            getContracts(paginationModel, sorting.field, sorting.sort, filtering, rentalContractSearch)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, filtering, sorting, contractId, selectedLocation, includeReserved, includeCheckedOut, includeCheckingIn, includeCheckedIn, includeCanceled])

    return (
        (<React.Fragment>
            <Grid container space={1}>
                <Grid xs>
                    {contractId === undefined && <Box>
                        <Grid container columnSpacing={1} sx={{ mr: 1, ml: 1, mt: 0.5, mb: 0.5 }} direction="row" justifyContent="center" alignItems="center">
                            <Grid xs>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="contractsearch"
                                    label="Search customer name or phone number"
                                    type="text"
                                    variant="filled"
                                    disabled={isLoading}
                                    value={rentalContractSearch}
                                    onChange={updateRentalContractSearch}
                                    slotProps={{
                                        input: {
                                            inputProps: { min: 1 },
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    {<SearchIcon />}
                                                </InputAdornment>
                                            ),
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid xs>
                                <Button disabled={isLoading} color={RENTAL_CONTRACT_COLOR_MAP["RESERVED"]} variant={includeReserved ? "contained" : "outlined"} onClick={() => setIncludeReserved(!includeReserved)}>Reserved</Button>
                            </Grid>
                            <Grid xs>
                                <Button disabled={isLoading} color={RENTAL_CONTRACT_COLOR_MAP["CHECKED_OUT"]} variant={includeCheckedOut ? "contained" : "outlined"} onClick={() => setIncludeCheckedOut(!includeCheckedOut)}>Checked Out</Button>
                            </Grid>
                            <Grid xs>
                                <Button disabled={isLoading} color={RENTAL_CONTRACT_COLOR_MAP["CHECKING_IN"]} variant={includeCheckingIn ? "contained" : "outlined"} onClick={() => setIncludeCheckingIn(!includeCheckingIn)}>Checking In</Button>
                            </Grid>
                            <Grid xs>
                                <Button disabled={isLoading} color={RENTAL_CONTRACT_COLOR_MAP["CHECKED_IN"]} variant={includeCheckedIn ? "contained" : "outlined"} onClick={() => setIncludeCheckedIn(!includeCheckedIn)}>Complete</Button>
                            </Grid>
                            <Grid xs>
                                <Button disabled={isLoading} color={RENTAL_CONTRACT_COLOR_MAP["CANCELED"]} variant={includeCanceled ? "contained" : "outlined"} onClick={() => setIncludeCanceled(!includeCanceled)}>Canceled</Button>
                            </Grid>
                        </Grid>
                        <DataGrid
                            slots={{
                                toolbar: () => SimpleCustomToolbar(),
                            }}
                            rows={rowData.rows}
                            rowCount={rowData.total_count}
                            columns={columns}
                            disableRowSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                            autoHeight={true}
                            filterMode={"server"}
                            loading={isLoading}
                            pageSizeOptions={[5, 10, 25, 50, 100]}
                            pagination
                            paginationMode="server"
                            paginationModel={paginationModel}
                            onPaginationModelChange={setMyPaginationModel}
                            onRowClick={contractsRowClick}
                            onSortModelChange={(params) => {
                                if (params[0] !== undefined) {
                                    setSorting(params[0])
                                } else {
                                    setSorting({ field: 'id', sort: 'asc' })
                                }
                            }}
                            onFilterModelChange={(params) => { setFiltering(onFilterChange(params)) }}
                        />
                    </Box>}
                    {contractId !== undefined && <Box>
                        <Contract
                            order={contractId}
                        />
                    </Box>}
                </Grid>
            </Grid>
        </React.Fragment>)
    );
}
